import { RoleName } from '~/types/api/user/role'
import { API } from '~/utils/api'

export default defineNuxtRouteMiddleware(async (to) => {
  // Only apply this middleware to the server-related routes
  if (!to.path.startsWith('/dashboard/servers')) {
    return
  }

  const pnapi = new API()
  const accessLevel = [RoleName.superadmin, RoleName.developer, RoleName.webadmin, RoleName.webdept, RoleName.marketingdept]
  
  try {
    const hasAccess = await pnapi.user().checkAccess(accessLevel)
    if (!hasAccess) {
      // Store access status in the route state for UI display
      to.meta.hasAccess = false
    } else {
      to.meta.hasAccess = true
    }
  } catch (error) {
    console.error('Error checking access in middleware:', error)
    to.meta.hasAccess = false
  }
  
  // Continue navigation - we'll handle displaying access denied message in the component
  // instead of redirecting
}) 